import React, { useEffect, useState, useCallback, useRef } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import "../css/InstQuestionsPage.css";
import { API_URL } from "../config";
import "mathlive";
import "../css/mathlive.core.css";
import { FaArrowLeft } from "react-icons/fa";
import { MathfieldElement } from "mathlive";
import "katex/dist/katex.min.css";
import axios from "axios";
import { BlockMath, InlineMath } from "react-katex";
// import PageMaxWidth from "../components/page-max-width";
import MarksForm from "../components/questions/MarksForm";
import ObjectiveSection from "../components/questions/ObjectiveForm";
import TheorySection from "../components/questions/TheoryForm";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import { authFetch } from "../utils/authfetch";
import UploadExamPDF from "./InstQuestionPDF";
import {
  FaClipboardList,
  FaFilePdf,
  FaListUl,
  FaPenNib,
  FaLock,
} from "react-icons/fa";
import {
  Box,
  Paper,
  Stack,
  Typography,
  IconButton,
  Tabs,
  Tab,
  Chip,
} from "@mui/material";
import LoadingPage from "../components/loading";

const QUESTION_CHOICES = ["A", "B", "C", "D"];
if (!customElements.get("math-field")) {
  customElements.define("math-field", MathfieldElement);
}

const tokenString = localStorage.getItem("authToken");
let headers = {
  "Content-Type": "application/json",
};

if (tokenString) {
  try {
    const token = JSON.parse(tokenString);
    headers.Authorization = `Bearer ${token.access}`;
  } catch (e) {
    console.warn("Failed to parse authToken:", e);
  }
}

const InstQuestionsPage = () => {
  const location = useLocation();
  const [OBJmode, setOBJMode] = useState("text");
  const [Optmode, setOptMode] = useState("text");
  const [TQmode, setTQMode] = useState("text");
  const [TAmode, setTAMode] = useState("text");
  const [value, setValue] = React.useState(0);
  const [showObjectiveGen, setShowObjectiveGen] = useState(false);
  const [showTheoryGen, setShowTheoryGen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [deleteType, setDeleteType] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [loadingSpin, setLoadingSpin] = useState(true);
  const [loadingobj, setLoadingObj] = useState(false);
  const [loadingthry, setLoadingThry] = useState(false);
  const [loadingautobj, setLoadingAutobj] = useState(false);
  const [loadingautothry, setLoadingAutothry] = useState(false);
  const toggleObjective = () => setShowObjectiveGen((prev) => !prev);
  const toggleTheory = () => setShowTheoryGen((prev) => !prev);
  const { subId } = useParams();
  const subjectName = location.state?.subjectName || "";
  const classId = location.state?.classId || "";
  const [instObjs, setInstObjs] = useState([]);
  const [instTheories, setInstTheories] = useState([]);
  const [numObjQuestions, setNumObjQuestions] = useState("");
  const [numThryQuestions, setNumThryQuestions] = useState("");

  const [objForm, setObjForm] = useState({
    question_text: "",
    option_a: "",
    option_b: "",
    option_c: "",
    option_d: "",
    correct_answer: "",
  });
  const [theoryForm, setTheoryForm] = useState({
    Question: "",
    answer: "",
    marks: "",
  });
  const [editingObj, setEditingObj] = useState(null);
  const [editingTheory, setEditingTheory] = useState(null);
  const objQImageInputRef = useRef(null);
  const questionImageInputRef = useRef(null);
  const answerImageInputRef = useRef(null);
  const [expandedObjId, setExpandedObjId] = useState(null);
  const [expandedTheoryId, setExpandedTheoryId] = useState(null);
  const [editDisabledId, setEditDisabledId] = useState(null);
  const navigate = useNavigate();
  const [isRemovingBg, setIsRemovingBg] = useState(false);

  // File + preview states for “objective question”
  const [objImageFile, setObjImageFile] = useState(null);
  const [objImagePreview, setObjImagePreview] = useState("");

  const [questionImageFile, setQuestionImageFile] = useState(null);
  const [answerImageFile, setAnswerImageFile] = useState(null);
  const [questionImagePreview, setQuestionImagePreview] = useState("");
  const [answerImagePreview, setAnswerImagePreview] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [entries, setEntries] = useState([]);
  const [formData, setFormData] = useState({ Time: "00:00:00", marks: "" });
  const [editingId, setEditingId] = useState(null);
  const fetchData = useCallback(
    async (showSpinner = true) => {
      if (showSpinner) setLoadingSpin(true); // start loading only if allowed

      try {
        const objRes = await authFetch(`${API_URL}/instobj/${subId}/`);
        const theoryRes = await authFetch(`${API_URL}/insttheory/${subId}/`);

        if (
          [objRes.status, theoryRes.status].some(
            (status) => status === 403 || status === 404
          )
        ) {
          toast.error("You are not permitted to access this subject.");
          navigate(-1);
          return;
        }

        if (objRes.ok && theoryRes.ok) {
          setInstObjs(await objRes.json());
          setInstTheories(await theoryRes.json());
        } else {
          toast.error("Error loading questions.");
        }
      } catch (error) {
        console.error(error);
        toast.error("Network error. Please try again.");
      } finally {
        if (showSpinner) setLoadingSpin(false); // stop only if started
      }
    },
    [subId, navigate]
  );

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (token) {
      fetchData();
    }
  }, [fetchData]);

  console.log(instObjs);

  useEffect(() => {
    const fields = document.querySelectorAll("math-field");
    fields.forEach((mf) => {
      mf.addEventListener("beforeinput", (e) => {
        if (e.inputType === "insertLineBreak") {
          mf.executeCommand("moveToNextPlaceholder");
          e.preventDefault();
        }
      });
    });
  }, [objForm]);

  const questionRef = useRef();
  const optionRefs = {
    a: useRef(),
    b: useRef(),
    c: useRef(),
    d: useRef(),
  };

  useEffect(() => {
    if (editingObj) {
      setObjForm({
        question_text: editingObj.question_text || "",
        option_a: editingObj.option_a || "",
        option_b: editingObj.option_b || "",
        option_c: editingObj.option_c || "",
        option_d: editingObj.option_d || "",
        correct_answer: editingObj.correct_answer || "",
      });

      if (questionRef.current)
        questionRef.current.value = editingObj.question_text || "";
      if (optionRefs.a.current)
        optionRefs.a.current.value = editingObj.option_a || "";
      if (optionRefs.b.current)
        optionRefs.b.current.value = editingObj.option_b || "";
      if (optionRefs.c.current)
        optionRefs.c.current.value = editingObj.option_c || "";
      if (optionRefs.d.current)
        optionRefs.d.current.value = editingObj.option_d || "";
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editingObj]);

  const handleObjSubmit = async (e) => {
    setLoadingObj(true);
    e.preventDefault();
    if (!objForm.question_text.trim()) {
      toast.info("Please fill in the question field.");
      questionRef.current?.focus();
      return;
    }
    if (!objForm.option_a.trim()) {
      toast.info("Please fill in the question field.");
      optionRefs.a.current?.focus();
      return;
    }
    if (!objForm.option_b.trim()) {
      toast.info("Please fill in the question field.");
      optionRefs.b.current?.focus();
      return;
    }
    if (!objForm.option_c.trim()) {
      toast.info("Please fill in the question field.");
      optionRefs.c.current?.focus();
      return;
    }
    if (!objForm.option_d.trim()) {
      toast.info("Please fill in the question field.");
      optionRefs.d.current?.focus();
      return;
    }

    const method = editingObj ? "PUT" : "POST";
    const url = editingObj
      ? `${API_URL}/instobj/${subId}/${editingObj.id}/`
      : `${API_URL}/instobj/${subId}/`;

    const processedForm = {
      ...objForm,
      question_text: objForm.question_text,
      option_a: objForm.option_a,
      option_b: objForm.option_b,
      option_c: objForm.option_c,
      option_d: objForm.option_d,
      correct_answer: objForm.correct_answer,
    };

    let fetchOptions = { method, headers: { ...headers } };

    if (objImageFile) {
      // 2a) If there’s a new image file, use FormData
      const data = new FormData();
      Object.entries(processedForm).forEach(([k, v]) => data.append(k, v));
      data.append("image_url", objImageFile, "cleaned.png");

      delete fetchOptions.headers["Content-Type"];
      fetchOptions.body = data;
    } else {
      // 2b) No new image → just JSON
      fetchOptions.body = JSON.stringify(processedForm);
      fetchOptions.headers["Content-Type"] = "application/json";
    }

    const res = await fetch(url, fetchOptions);
    if (res.ok) {
      const savedQuestion = await res.json();

      setInstObjs((prev) => {
        if (editingObj) {
          // update in place
          return prev.map((q) =>
            q.id === savedQuestion.id ? savedQuestion : q
          );
        }
        // new question
        return [savedQuestion, ...prev];
      });
      setObjForm({
        question_text: "",
        option_a: "",
        option_b: "",
        option_c: "",
        option_d: "",
        correct_answer: "",
      });
      if (questionRef.current) questionRef.current.value = "";
      Object.values(optionRefs).forEach((ref) => {
        if (ref.current) ref.current.value = "";
      });
      setEditingObj(null);

      setObjImageFile(null);
      setObjImagePreview("");
      if (objQImageInputRef.current) objQImageInputRef.current.value = "";
      setEditDisabledId(null);
    } else {
      const error = await res.text();
      console.error("Failed to save objective:", error);
    }
    setLoadingObj(false);
  };

  const TheoryQuestionRef = useRef();
  const TheoryAnswerRef = useRef();
  const TheoryMarksRef = useRef();

  useEffect(() => {
    if (editingTheory) {
      setTheoryForm({
        Question: editingTheory.Question || "",
        answer: editingTheory.answer || "",
        marks: editingTheory.marks || "",
      });

      if (TheoryQuestionRef.current)
        TheoryQuestionRef.current.value = editingTheory.Question || "";
      if (TheoryAnswerRef.current)
        TheoryAnswerRef.current.value = editingTheory.answer || "";
      if (TheoryMarksRef.current)
        TheoryMarksRef.current.value = editingTheory.marks || "";
      setQuestionImagePreview(editingTheory.question_image || "");
      setAnswerImagePreview(editingTheory.answer_image || "");
    }
  }, [editingTheory]);

  const handleTheorySubmit = async (e) => {
    e.preventDefault();
    if (!theoryForm.Question.trim()) {
      toast.info("Please fill in the question field.");
      TheoryQuestionRef.current?.focus();
      return;
    }
    setLoadingThry(true);
    const method = editingTheory ? "PUT" : "POST";
    const url = editingTheory
      ? `${API_URL}/insttheory/${subId}/${editingTheory.id}/`
      : `${API_URL}/insttheory/${subId}/`;

    const processed = {
      Question: theoryForm.Question,
      answer: theoryForm.answer,
      marks: theoryForm.marks,
    };

    let fetchOptions = { method, headers: { ...headers } };

    const isMultipart = questionImageFile || answerImageFile;

    if (isMultipart) {
      const data = new FormData();
      Object.entries(processed).forEach(([k, v]) => data.append(k, v));

      if (questionImageFile)
        data.append(
          "question_image",
          questionImageFile,
          questionImageFile.name || "question.png"
        ); // ✅ use name
      if (answerImageFile)
        data.append(
          "answer_image",
          answerImageFile,
          answerImageFile.name || "answer.png"
        ); // ✅ use name

      delete fetchOptions.headers["Content-Type"];
      fetchOptions.body = data;
    } else {
      fetchOptions.body = JSON.stringify(processed);
      fetchOptions.headers["Content-Type"] = "application/json";
    }

    const res = await fetch(url, fetchOptions);
    if (res.ok) {
      const savedTheory = await res.json();

      setInstTheories((prev) => {
        if (editingTheory) {
          return prev.map((q) => (q.id === savedTheory.id ? savedTheory : q));
        }
        return [savedTheory, ...prev];
      });

      setTheoryForm({ Question: "", answer: "", marks: "" });
      setEditingTheory(null);
      setQuestionImageFile(null);
      setAnswerImageFile(null);
      setQuestionImagePreview("");
      setAnswerImagePreview("");
      if (TheoryQuestionRef.current) TheoryQuestionRef.current.value = "";
      if (TheoryAnswerRef.current) TheoryAnswerRef.current.value = "";
      if (TheoryMarksRef.current) TheoryMarksRef.current.value = "";
      if (questionImageInputRef.current)
        questionImageInputRef.current.value = "";
      if (answerImageInputRef.current) answerImageInputRef.current.value = "";
      setEditDisabledId(null);
      toast.success("saved theory question successfully");
    } else {
      const errorData = await res.json().catch(() => null);
      console.error("Failed to save theory:", errorData || (await res.text()));
    }
    setLoadingThry(false);
  };

  const confirmDelete = async () => {
    if (!deleteId || !deleteType) return;

    const url = `${API_URL}/${deleteType}/${subId}/${deleteId}/`;

    try {
      setDeleteLoading(true);

      const res = await fetch(url, { method: "DELETE", headers });

      if (res.ok) {
        // remove instantly from UI
        setInstObjs((prev) => prev.filter((q) => q.id !== deleteId));

        toast.success("Deleted successfully!");
      } else {
        const err = await res.text();
        toast.error("Delete failed: " + err);
      }
    } catch (err) {
      toast.error("Delete error: " + err.message);
    } finally {
      setDeleteOpen(false);
      setDeleteLoading(false);
      setDeleteId(null);
      setDeleteType(null);
    }
  };

  const handleObjImageUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    try {
      setIsRemovingBg(true);
      const blob = await removeBackgroundWithRemoveBg(file);
      setObjImageFile(blob);
      setObjImagePreview(URL.createObjectURL(blob));
    } catch {
      setObjImageFile(file);
      setObjImagePreview(URL.createObjectURL(file));
    } finally {
      setIsRemovingBg(false);
    }
  };

  const handleQuestionImageUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    try {
      setIsRemovingBg(true);
      const blob = await removeBackgroundWithRemoveBg(file);
      setQuestionImageFile(blob);
      setQuestionImagePreview(URL.createObjectURL(blob));
    } catch (err) {
      console.error("Background removal failed:", err);
      setQuestionImageFile(file);
      setQuestionImagePreview(URL.createObjectURL(file));
    } finally {
      setIsRemovingBg(false);
    }
  };

  const handleAnswerImageUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    try {
      setIsRemovingBg(true);
      const blob = await removeBackgroundWithRemoveBg(file);
      setAnswerImageFile(blob);
      setAnswerImagePreview(URL.createObjectURL(blob));
    } catch (err) {
      console.error("Background removal failed:", err);
      setAnswerImageFile(file);
      setAnswerImagePreview(URL.createObjectURL(file));
    } finally {
      setIsRemovingBg(false);
    }
  };

  const removeBackgroundWithRemoveBg = async (file) => {
    const formData = new FormData();
    formData.append("image_file", file);
    formData.append("size", "auto");

    const res = await fetch("https://api.remove.bg/v1.0/removebg", {
      method: "POST",
      headers: {
        "X-Api-Key": "hxRA6YNfZzrnsXgMYv9ZBYCh", // <-- Replace this
      },
      body: formData,
    });

    if (!res.ok) {
      const errorText = await res.text();
      throw new Error(`Remove.bg error: ${errorText}`);
    }

    const blob = await res.blob();
    return blob;
  };

  useEffect(() => {
    axios
      .get(`${API_URL}/exam-marks/${subId}/`, { headers })
      .then((res) => setEntries(res.data))
      .catch((err) => console.error(err));
  }, [subId]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return;

    if (!formData.Time || !formData.marks) {
      return toast.warn("Please fill in all fields before submitting.");
    }

    setIsSubmitting(true);

    const data = {
      Time: formData.Time,
      marks: formData.marks,
    };

    try {
      if (editingId) {
        const res = await axios.put(
          `${API_URL}/exam-marks/${subId}/${editingId}/`,
          data,
          { headers }
        );

        setEntries((prev) =>
          prev.map((item) => (item.id === editingId ? res.data : item))
        );

        toast.success("Successfully updated! 🚀");
      } else {
        const res = await axios.post(`${API_URL}/exam-marks/${subId}/`, data, {
          headers,
        });

        setEntries((prev) => {
          const exists = prev.some((item) => item.id === res.data.id);

          if (exists) return prev;

          return [...prev, res.data];
        });

        toast.success("Marks saved successfully! 🎉");
      }

      setFormData({ Time: "", marks: "" });
      setEditingId(null);
    } catch (err) {
      toast.error("Something went wrong ❌");
      console.error(err);
    } finally {
      setIsSubmitting(false);
    }
  };
  const hasEntry = entries && entries.length > 0;
  console.log(hasEntry);
  const startEdit = (entry) => {
    setEditingId(entry.id);
    setFormData({
      Time: entry.Time,
      marks: entry.marks,
    });
  };
  const disableAdd =
    !formData.Time || !formData.marks || (entries.length > 0 && !editingId); // Disallow "Add" if entry exists and not editing

  const isEditing = Boolean(editingId);

  const handleBackClick = () => {
    navigate(-1);
  };

  const renderContent = (text) => {
    if (!text) return null;

    const parts = text.split(
      /(\$\$[\s\S]+?\$\$|\\\[[\s\S]+?\\\]|\\\([\s\S]+?\\\)|\$[^$]+\$)/g
    );

    return parts.map((part, index) => {
      // $$...$$ (block)
      if (part.startsWith("$$") && part.endsWith("$$")) {
        return (
          <div key={index} style={{ margin: "10px 0" }}>
            <BlockMath math={part.slice(2, -2)} />
          </div>
        );
      }

      // \[...\] (block)
      if (part.startsWith("\\[") && part.endsWith("\\]")) {
        return (
          <div key={index} style={{ margin: "10px 0" }}>
            <BlockMath math={part.slice(2, -2)} />
          </div>
        );
      }

      // \(...\) (inline)
      if (part.startsWith("\\(") && part.endsWith("\\)")) {
        return <InlineMath key={index} math={part.slice(2, -2)} />;
      }

      // $...$ (inline)
      if (part.startsWith("$") && part.endsWith("$")) {
        return <InlineMath key={index} math={part.slice(1, -1)} />;
      }

      // Normal text
      return (
        <span key={index} style={{ whiteSpace: "pre-line" }}>
          {part}
        </span>
      );
    });
  };

  const handleAutoExamObjective = async () => {
    try {
      setLoadingAutobj(true);
      const url = `${API_URL}/pick-questions-objective/${subId}/`;

      const payload = {
        class_id: classId,
        num_questions: Number(numObjQuestions),
      };

      const res = await fetch(url, {
        method: "POST",
        headers,
        body: JSON.stringify(payload),
      });

      if (res.ok) {
        const data = await res.json();
        toast.success("Auto exam successfully generated!");
        console.log("Auto exam data:", data);
        await fetchData(); // refresh questions
      } else {
        const errorText = await res.text();
        console.error("Auto exam failed:", errorText);
        toast.error("Failed to generate auto exam");
      }
    } catch (err) {
      console.error("Error:", err);
      toast.error("Error generating auto exam");
    } finally {
      setLoadingAutobj(false);
    }
  };

  const handleAutoExamTheory = async () => {
    try {
      setLoadingAutothry(true);
      const url = `${API_URL}/pick-theory-questions/${subId}/`;

      const payload = {
        class_id: classId,
        num_questions: Number(numThryQuestions),
      };

      const res = await fetch(url, {
        method: "POST",
        headers,
        body: JSON.stringify(payload),
      });

      if (res.ok) {
        const data = await res.json();
        toast.success("Auto exam successfully generated!");
        console.log("Auto exam data:", data);
        await fetchData(false); // refresh questions
      } else {
        const errorText = await res.text();
        console.error("Auto exam failed:", errorText);
        toast.error("Failed to generate auto exam");
      }
    } catch (err) {
      console.error("Error:", err);
      toast.error("Error generating auto exam");
    } finally {
      setLoadingAutothry(false);
    }
  };
  const handleChange = (_event, newValue) => {
    setValue(newValue);
  };

  if (loadingSpin) {
    return <LoadingPage />;
  }

  // ── Main Return ──────────────────────────────────────────────────────────────
  return (
    <Box
      sx={{
        minHeight: "100vh",
        background:
          "linear-gradient(135deg, #e0f2fe 0%, #f0f9ff 50%, #e1f5fe 100%)",
        py: 4,
        px: { xs: 2, md: 4 },
      }}
    >
      {/* ── Header ─────────────────────────────────────────────────────────── */}
      <Paper
        elevation={0}
        sx={{
          p: { xs: 2, md: 3 },
          mb: 3,
          borderRadius: 3,
          background: "#fff",
          border: "1px solid rgba(2,136,209,0.15)",
          boxShadow: "0 2px 12px rgba(2,136,209,0.08)",
        }}
      >
        <Stack direction="row" alignItems="center" spacing={2}>
          <IconButton
            onClick={handleBackClick}
            sx={{
              color: "#0288D1",
              background: "rgba(2,136,209,0.08)",
              border: "1px solid rgba(2,136,209,0.2)",
              "&:hover": { background: "rgba(2,136,209,0.15)" },
            }}
          >
            <FaArrowLeft size={16} />
          </IconButton>

          <Box sx={{ flex: 1 }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: 800,
                color: "#0c1a2e",
                letterSpacing: "-0.5px",
                textTransform: "uppercase",
              }}
            >
              {subjectName || "Subject"}
            </Typography>
            <Typography variant="caption" sx={{ color: "#64748b" }}>
              Manage exam questions and entries
            </Typography>
          </Box>

          {/* Mode indicators */}
          <Stack direction="row" spacing={1}>
            <Chip
              label="Objective"
              size="small"
              icon={
                <FaListUl
                  size={10}
                  style={{
                    marginLeft: 8,
                    color: value === 0 ? "#0288D1" : "#94a3b8",
                  }}
                />
              }
              sx={{
                fontWeight: 700,
                fontSize: "0.72rem",
                background: value === 0 ? "rgba(2,136,209,0.1)" : "#f1f5f9",
                color: value === 0 ? "#0288D1" : "#94a3b8",
                border: `1px solid ${
                  value === 0 ? "rgba(2,136,209,0.25)" : "#e2e8f0"
                }`,
              }}
            />
            <Chip
              label="Theory"
              size="small"
              icon={
                <FaPenNib
                  size={10}
                  style={{
                    marginLeft: 8,
                    color: value === 1 ? "#7c3aed" : "#94a3b8",
                  }}
                />
              }
              sx={{
                fontWeight: 700,
                fontSize: "0.72rem",
                background: value === 1 ? "rgba(124,58,237,0.1)" : "#f1f5f9",
                color: value === 1 ? "#7c3aed" : "#94a3b8",
                border: `1px solid ${
                  value === 1 ? "rgba(124,58,237,0.25)" : "#e2e8f0"
                }`,
              }}
            />
          </Stack>
        </Stack>
      </Paper>

      {/* ── Marks Form ─────────────────────────────────────────────────────── */}
      <Paper
        elevation={0}
        sx={{
          mb: 3,
          borderRadius: 3,
          background: "#fff",
          border: "1px solid rgba(2,136,209,0.15)",
          boxShadow: "0 2px 12px rgba(2,136,209,0.08)",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            px: 2.5,
            py: 2,
            borderBottom: "1px solid #e2e8f0",
            background:
              "linear-gradient(135deg, rgba(2,136,209,0.05), rgba(14,165,233,0.03))",
          }}
        >
          <Stack direction="row" alignItems="center" spacing={1.5}>
            <Box
              sx={{
                width: 32,
                height: 32,
                borderRadius: 1.5,
                background: "linear-gradient(135deg, #0288D1, #0ea5e9)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 4px 10px rgba(2,136,209,0.3)",
              }}
            >
              <FaClipboardList size={14} color="#fff" />
            </Box>
            <Box>
              <Typography
                sx={{ fontWeight: 800, color: "#0c1a2e", fontSize: "0.92rem" }}
              >
                Exam Entry
              </Typography>
              <Typography variant="caption" sx={{ color: "#64748b" }}>
                {isEditing
                  ? "Editing existing entry"
                  : "Create a new exam entry"}
              </Typography>
            </Box>
          </Stack>
        </Box>
        <Box sx={{ p: 2.5 }}>
          <MarksForm
            handleSubmit={handleSubmit}
            formData={formData}
            setFormData={setFormData}
            entries={entries}
            disableAdd={disableAdd}
            isEditing={isEditing}
            startEdit={startEdit}
            isSubmitting={isSubmitting}
          />
        </Box>
      </Paper>

      {/* ── Upload Exam PDF ─────────────────────────────────────────────────── */}
      <Paper
        elevation={0}
        sx={{
          mb: 3,
          borderRadius: 3,
          background: "#fff",
          border: "1px solid rgba(2,136,209,0.15)",
          boxShadow: "0 2px 12px rgba(2,136,209,0.08)",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            px: 2.5,
            py: 2,
            borderBottom: "1px solid #e2e8f0",
            background:
              "linear-gradient(135deg, rgba(239,68,68,0.04), rgba(239,68,68,0.02))",
          }}
        >
          <Stack direction="row" alignItems="center" spacing={1.5}>
            <Box
              sx={{
                width: 32,
                height: 32,
                borderRadius: 1.5,
                background: "linear-gradient(135deg, #ef4444, #f87171)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 4px 10px rgba(239,68,68,0.25)",
              }}
            >
              <FaFilePdf size={14} color="#fff" />
            </Box>
            <Box>
              <Typography
                sx={{ fontWeight: 800, color: "#0c1a2e", fontSize: "0.92rem" }}
              >
                Upload Exam PDF
              </Typography>
              <Typography variant="caption" sx={{ color: "#64748b" }}>
                Attach exam paper document
              </Typography>
            </Box>
          </Stack>
        </Box>
        <Box sx={{ p: 2.5 }}>
          {!hasEntry ? (
            <Box
              sx={{
                textAlign: "center",
                py: 8,
                px: 2,
              }}
            >
              <Box
                sx={{
                  width: 64,
                  height: 64,
                  borderRadius: "50%",
                  background: "rgba(2,136,209,0.08)",
                  border: "1px solid rgba(2,136,209,0.15)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mx: "auto",
                  mb: 2,
                }}
              >
                <FaLock size={22} color="#0288D1" />
              </Box>
              <Typography sx={{ fontWeight: 700, color: "#0c1a2e", mb: 0.5 }}>
                No Exam Entry Yet
              </Typography>
              <Typography variant="caption" sx={{ color: "#94a3b8" }}>
                Create an exam entry above before uploading pdfs .
              </Typography>
            </Box>
          ) : (
            <UploadExamPDF subId={subId} fetchData={fetchData} />
          )}
        </Box>
      </Paper>

      {/* ── Questions Tabs ──────────────────────────────────────────────────── */}
      <Paper
        elevation={0}
        sx={{
          borderRadius: 3,
          background: "#fff",
          border: "1px solid rgba(2,136,209,0.15)",
          boxShadow: "0 2px 12px rgba(2,136,209,0.08)",
          overflow: "hidden",
        }}
      >
        {/* Tab headers */}
        <Box
          sx={{
            borderBottom: "1px solid #e2e8f0",
            px: 2,
            pt: 1,
            background:
              "linear-gradient(135deg, rgba(2,136,209,0.03), rgba(14,165,233,0.01))",
          }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            variant="fullWidth"
            aria-label="exam question tabs"
            sx={{
              "& .MuiTab-root": {
                color: "#94a3b8",
                fontWeight: 700,
                fontSize: "0.85rem",
                textTransform: "none",
                letterSpacing: "0.2px",
                minHeight: 52,
                transition: "color 0.2s",
                "&.Mui-selected": { color: "#0c1a2e" },
                "&.Mui-disabled": { opacity: 0.35 },
              },
              "& .MuiTabs-indicator": {
                height: 3,
                borderRadius: "3px 3px 0 0",
              },
            }}
          >
            <Tab
              {...a11yProps(0)}
              disabled={!hasEntry}
              icon={<FaListUl size={14} />}
              iconPosition="start"
              label={
                <Stack direction="row" alignItems="center" spacing={1}>
                  <span>Objective Mode</span>
                  {!hasEntry && (
                    <Chip
                      label="Locked"
                      size="small"
                      sx={{
                        height: 16,
                        fontSize: "0.6rem",
                        fontWeight: 700,
                        background: "rgba(100,116,139,0.1)",
                        color: "#94a3b8",
                        border: "none",
                      }}
                    />
                  )}
                </Stack>
              }
              sx={{
                "&.Mui-selected": { color: "#0288D1" },
                "& .MuiTabs-indicator": { background: "#0288D1" },
              }}
            />
            <Tab
              {...a11yProps(1)}
              disabled={!hasEntry}
              icon={<FaPenNib size={14} />}
              iconPosition="start"
              label={
                <Stack direction="row" alignItems="center" spacing={1}>
                  <span>Theory Mode</span>
                  {!hasEntry && (
                    <Chip
                      label="Locked"
                      size="small"
                      sx={{
                        height: 16,
                        fontSize: "0.6rem",
                        fontWeight: 700,
                        background: "rgba(100,116,139,0.1)",
                        color: "#94a3b8",
                        border: "none",
                      }}
                    />
                  )}
                </Stack>
              }
              sx={{
                "&.Mui-selected": { color: "#7c3aed" },
              }}
            />
          </Tabs>
        </Box>

        {/* Custom indicator color per tab via wrapper */}
        <Box
          sx={{
            "& .MuiTabs-indicator": {
              background:
                value === 0
                  ? "linear-gradient(90deg, #0288D1, #0ea5e9)"
                  : "linear-gradient(90deg, #7c3aed, #a855f7)",
            },
          }}
        />

        {/* ── Objective Tab ─────────────────────────────────────────────────── */}
        <TabPanel value={value} index={0}>
          {!hasEntry ? (
            <Box
              sx={{
                textAlign: "center",
                py: 8,
                px: 2,
              }}
            >
              <Box
                sx={{
                  width: 64,
                  height: 64,
                  borderRadius: "50%",
                  background: "rgba(2,136,209,0.08)",
                  border: "1px solid rgba(2,136,209,0.15)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mx: "auto",
                  mb: 2,
                }}
              >
                <FaLock size={22} color="#0288D1" />
              </Box>
              <Typography sx={{ fontWeight: 700, color: "#0c1a2e", mb: 0.5 }}>
                No Exam Entry Yet
              </Typography>
              <Typography variant="caption" sx={{ color: "#94a3b8" }}>
                Create an exam entry above before adding objective questions.
              </Typography>
            </Box>
          ) : (
            <ObjectiveSection
              subId={subId}
              tokenString={tokenString}
              subjectName={subjectName}
              numObjQuestions={numObjQuestions}
              setNumObjQuestions={setNumObjQuestions}
              showObjectiveGen={showObjectiveGen}
              toggleObjective={toggleObjective}
              handleAutoExamObjective={handleAutoExamObjective}
              loadingautobj={loadingautobj}
              handleObjSubmit={handleObjSubmit}
              objImagePreview={objImagePreview}
              editingObj={editingObj}
              isRemovingBg={isRemovingBg}
              OBJmode={OBJmode}
              setOBJMode={setOBJMode}
              Optmode={Optmode}
              setOptMode={setOptMode}
              objForm={objForm}
              setObjForm={setObjForm}
              questionRef={questionRef}
              optionRefs={optionRefs}
              objQImageInputRef={objQImageInputRef}
              handleObjImageUpload={handleObjImageUpload}
              loadingobj={loadingobj}
              instObjs={instObjs}
              expandedObjId={expandedObjId}
              setExpandedObjId={setExpandedObjId}
              editDisabledId={editDisabledId}
              setEditDisabledId={setEditDisabledId}
              renderContent={renderContent}
              deleteOpen={deleteOpen}
              setDeleteOpen={setDeleteOpen}
              confirmDelete={confirmDelete}
              setDeleteId={setDeleteId}
              setDeleteType={setDeleteType}
              setEditingObj={setEditingObj}
              setInstObjs={setInstObjs}
              QUESTION_CHOICES={QUESTION_CHOICES}
              deleteLoading={deleteLoading}
            />
          )}
        </TabPanel>

        {/* ── Theory Tab ────────────────────────────────────────────────────── */}
        <TabPanel value={value} index={1}>
          <TheorySection
            subId={subId}
            tokenString={tokenString}
            subjectName={subjectName}
            numThryQuestions={numThryQuestions}
            setNumThryQuestions={setNumThryQuestions}
            showTheoryGen={showTheoryGen}
            toggleTheory={toggleTheory}
            handleAutoExamTheory={handleAutoExamTheory}
            loadingautothry={loadingautothry}
            handleTheorySubmit={handleTheorySubmit}
            questionImagePreview={questionImagePreview}
            answerImagePreview={answerImagePreview}
            editingTheory={editingTheory}
            isRemovingBg={isRemovingBg}
            TQmode={TQmode}
            setTQMode={setTQMode}
            TAmode={TAmode}
            setTAMode={setTAMode}
            theoryForm={theoryForm}
            setTheoryForm={setTheoryForm}
            TheoryQuestionRef={TheoryQuestionRef}
            TheoryAnswerRef={TheoryAnswerRef}
            questionImageInputRef={questionImageInputRef}
            answerImageInputRef={answerImageInputRef}
            handleQuestionImageUpload={handleQuestionImageUpload}
            handleAnswerImageUpload={handleAnswerImageUpload}
            loadingthry={loadingthry}
            instTheories={instTheories}
            expandedTheoryId={expandedTheoryId}
            setExpandedTheoryId={setExpandedTheoryId}
            editDisabledId={editDisabledId}
            setEditDisabledId={setEditDisabledId}
            renderContent={renderContent}
            setEditingTheory={setEditingTheory}
            deleteOpen={deleteOpen}
            setDeleteOpen={setDeleteOpen}
            confirmDelete={confirmDelete}
            setDeleteId={setDeleteId}
            setDeleteType={setDeleteType}
            setInstTheories={setInstTheories}
          />
        </TabPanel>
      </Paper>
    </Box>
  );
};

export default InstQuestionsPage;

// ── TabPanel & a11yProps ─────────────────────────────────────────────────────
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box
          sx={{
            p: { xs: 2, md: 3 },
            wordBreak: "break-word",
            whiteSpace: "normal",
          }}
        >
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}
